// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1561) return "static/chunks/1561.a5fb6e64b9b18ed4.js";
	// return url for filenames based on template
	return "static/chunks/" + {"845":"17a9af85","9031":"e89fb3a8"}[chunkId] + "-" + {"845":"bd249d081e608ecc","9031":"4003a3bb6ff0f1b7"}[chunkId] + ".js";
};